export default __webpack_public_path__ + "static/introImage-0e5dcbe37bc93731a9f02d2c6d31dd68.png";